import { render } from "./LeagueStatsComparison-LastNMatchesStat.vue.vue?vue&type=template&id=25ab6a98&scoped=true"
import script from "./LeagueStatsComparison-LastNMatchesStat.vue.vue?vue&type=script&lang=js"
export * from "./LeagueStatsComparison-LastNMatchesStat.vue.vue?vue&type=script&lang=js"

import "./LeagueStatsComparison-LastNMatchesStat.vue.vue?vue&type=style&index=0&id=25ab6a98&scoped=true&lang=css"
import "./LeagueStatsComparison-LastNMatchesStat.vue.vue?vue&type=style&index=1&id=25ab6a98&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ab6a98"]])

export default __exports__